<template>
  <div v-if="item">
    <div class="a-container-form">
      <button class="gui-btn gui-btn--red gui-btn--w-184" @click.prevent="onDownloadClick" v-t="'buttons.download-template'"></button>
    </div>
    <div class="a-container-form">
      <div class="a-width-100-percent">
        <textarea class="a-textarea a-width-100-percent" rows="10" v-model="description"></textarea>
      </div>
    </div>
    <div class="a-container-form">
      <div class="a-input-file-block">
        <file-link :removable="true"
                   :name="file.name"
                   :size="file.size"
                   @remove="file = undefined"
                   v-if="file">

        </file-link>
        <file-picker mode="button"
                     :accept="extension"
                     :signing="false"
                     @prepared="onFileSelected">
        </file-picker>
      </div>
    </div>

    <div class="personal-data__btn-block" v-if="item">
      <button class="gui-btn gui-btn--white-border gui-btn--w-140" :disabled="!isChanged" @click.prevent="onCancelClick" v-t="'buttons.cancel'"></button>
      <button class="gui-btn gui-btn--white-border gui-btn--w-140" :disabled="!isChanged" @click.prevent="onSaveClick" v-t="'buttons.save'"></button>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    props: {
      item: Object
    },

    data: () => ({
      template: undefined,
      description: undefined,
      file: undefined
    }),

    computed: {
      extension() {
        return _.get(this.item, 'extension', '').slice(1);
      },

      isChanged() {
        return this.file !== undefined || this.description !== this.item.description;
      }
    },

    watch: {
      item() {
        this.description = this.item.description;
        this.file = undefined;
      }
    },

    methods: {
      async onDownloadClick() {
        try {
          await this.$store.dispatch('downloadAttachedTemplate', { type: this.item.reportType })
        }
        catch(e) {
          console.error('unable to download attached file', e);
          this.showError({
            label: 'errors.unable-to-download-template'
          })
        }
      },

      onFileSelected(file) {
        this.file = file;
      },

      async onSaveClick() {
        try {
          await this.$store.dispatch('updateTemplate', {
            type: this.item.reportType,
            description: this.description,
            file: this.file
          })
        }
        catch(e) {
          console.error('unable to update template', e);
          this.globalErrorHandler(e);
        }
      },

      onCancelClick() {
        this.description = this.item.description;
        this.file = undefined;
      }
    }
  }
</script>

<style scoped>

</style>
